<template>
  <div class="app-container">
    <el-tabs v-model="activeName">
      <!-- 关于我 -->
      <el-tab-pane label="关于我" name="about">
        <mavon-editor
            v-model="aboutContent"
            style="height:calc(100vh - 285px);z-index: 8"
        />
        <el-button
            v-hasPermi="['system:blog:edit']"
            type="danger"
            class="edit-btn"
            @click="updateAbout"
        >
          修改
        </el-button>
      </el-tab-pane>
      <!-- 公告 -->
      <el-tab-pane label="公告" name="notice">
        <el-form ref="noticeForm" label-width="0px" :model="noticeForm" :rules="noticeRules">
          <el-form-item prop="notice">
            <el-input v-model="noticeForm.notice" placeholder="请输入公告内容" type="textarea" :rows="5"/>
          </el-form-item>
          <el-form-item align="right">
            <el-button v-hasPermi="['system:blog:edit']" type="danger" size="mini" @click="updateNotice">修改</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import { getBlogInfo, saveAbout, saveNotice} from "@/api/bloginfo";
export default {
  created() {
    this.blogInfo();
  },
  data: function() {
    return {
      activeName: "about",
      aboutContent: "",
      noticeForm: {},
      noticeRules: {
        notice: [
          { required: true, message: "公告不能为空", trigger: "blur" }
        ]
      },
    };
  },
  methods: {
    blogInfo() {
      getBlogInfo().then(response => {
        if(response.flag && response.data){
          const info = response.data;
          this.aboutContent = info.aboutMe;
          this.$set(this.noticeForm, "notice", info.notice);
        }
      });
    },
    updateAbout() {
      saveAbout({ aboutContent: this.aboutContent }).then(response => {
        if (response.flag) {
          this.$modal.msgSuccess("保存成功");
        } else {
          this.$modal.msgError("保存失败");
        }
      });
    },
    updateNotice() {
      this.$refs.noticeForm.validate(valid => {
        if(valid){
          saveNotice(this.noticeForm).then(response => {
            if (response.flag) {
              this.$modal.msgSuccess("保存成功");
            } else {
              this.$modal.msgError("保存失败");
            }
          });
        }
      })
    }
  }
};
</script>

<style scoped>
.edit-btn {
  float: right;
  margin: 1rem 0;
}
</style>
